import { ZoomImageContainer } from "shared/components/Parameters";
import Layout from "../../components/mainPage/Layout";
import IEC61850Client from "../../images/systemComponents/IEC61850Client.svg";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    МЭК 61850 (Клиент)
                </h1>
                <div className=" w-100 align-start ">
                    <p  >
                        <b>Клиент МЭК 61850 </b> в SCADA NPT Expert используется для взаимодействия с интеллектуальными электронными устройствами (IED) в энергетических системах.
                    </p>
                    <div style={{ float: 'right' }}>
                        <div style={{ maxWidth: '500px' }}>
                            <ZoomImageContainer
                                image={IEC61850Client}
                            />
                            {/* <img
                                style={{}}
                                src={IEC61850Client}
                                className="  w-100"
                                alt="IEC61850 Клиент"
                            /> */}
                        </div>

                    </div>


                    <div >
                        <p>Варианты применения:</p>

                        <ul className="mb-4 description__list">

                            <li className="mb-1 description__number-li">Сбор данных:
                                <ul>
                                    <li>Клиент МЭК 61850 подключается к IED и собирает данные в реальном времени (например, напряжение, ток, состояние оборудования).</li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li">Мониторинг и управление:
                                <ul>
                                    <li>
                                        SCADA NPT Expert использует клиента МЭК 61850 для мониторинга состояния энергетической сети и удалённого управления устройствами (например, включение/выключение выключателей).
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li">Стандартизация:
                                <ul>
                                    <li>
                                        МЭК 61850 обеспечивает единый стандарт обмена данными, что упрощает интеграцию устройств от разных производителей.
                                    </li>
                                </ul>
                            </li>
                            <li className="mb-1 description__number-li">События и аварии:
                                <ul>
                                    <li>
                                        Клиент МЭК 61850 получает данные о событиях пусков и срабатываний защит и автоматики, что позволяет оперативно реагировать на изменения в сети.
                                    </li>
                                </ul>
                            </li>

                        </ul>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                </div>



            </div>
        </div>
    </Layout>
}

export const meta = {
    title: 'МЭК 61850 (Клиент)',
    description: 'Клиент МЭК 61850  в SCADA NPT Expert используется для взаимодействия с интеллектуальными электронными устройствами (IED) в энергетических системах.'
}